import { LOCALSTORAGE_ACCESS_TOKEN } from '../../constants';

export const getAccessToken = (): string | null => {
    const accessToken = localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN);
    return accessToken  ? JSON.parse(accessToken) : null;
};
